export const environment = {
  production: true,
  apiEndPoint: 'https://app-echoapi-idec.azurewebsites.net/prod/api',
  baseHref: '/prod/webapp',
  azureBlobBaseUrl: 'https://az0blob0idec.blob.core.windows.net',
  appToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBOYW1lIjoiRWNobyBKb2IiLCJleHAiOjE3MzU2ODk1OTksIm5vT2ZEZXZpY2VzIjo1MCwibm9PZkJhdGNoZXMiOjUsImlhdCI6MTczMzE0NzQyOX0.o6rPr_Di8XD4JLFglBdTF4FQ3LWHRxA_TRUWPO-mYag',
  blobContainer: 'blob-file-idec',
  grafanaUrl: 'http://104.211.204.58:3000/d/e3daf11e-d3d7-4099-9ea9-5d5629ddb889/idec-observe-dashboard3a-v2'
};
